import React from "react";

const WhatsappIcon = () => {
  return (
    <>
      <div className="whatsapp_float">
        <a href="https://wa.me/919165155945" target="_blank">
          <img
            src="https://yogeshsolarenergy.com/WhatsappLogo_1.gif"
            // src="./WhatsappLogo.png"
            width="50px"
            className="whatsapp_float_btn"
          />
        </a>

      </div>
    </>
  );
};

export default WhatsappIcon;
